import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  autoplay: "",
  class: "video-header__video",
  height: "100%",
  loop: "",
  muted: "",
  width: "100%"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "hero__background"
}
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "hero__background-circles",
  viewBox: "0 0 1154 1154"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "#FFF",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "577",
      cy: "577",
      opacity: ".033",
      r: "577"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "577.5",
      cy: "576.5",
      opacity: ".037",
      r: "405.5"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "hero__body" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "w-75 text-white" }
const _hoisted_11 = {
  key: 0,
  class: "display-3 text-shadow"
}
const _hoisted_12 = {
  key: 1,
  class: "display-5"
}
const _hoisted_13 = { class: "hero__cta" }
const _hoisted_14 = {
  key: 3,
  class: "hero__footer"
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "hero__logos hidden-xs" }
const _hoisted_17 = ["alt"]
const _hoisted_18 = { class: "visible-xs" }
const _hoisted_19 = { class: "hero__logos" }
const _hoisted_20 = ["alt"]
const _hoisted_21 = {
  key: 4,
  class: "hero__footer"
}
const _hoisted_22 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSearchBar = _resolveComponent("HeroSearchBar")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hero", { 'has-image': _ctx.vm.backgroundImageUrl, [_ctx.backgroundColor]: _ctx.backgroundColor }])
  }, [
    (_ctx.vm.backgroundVideoUrl)
      ? (_openBlock(), _createElementBlock("video", _hoisted_1, [
          _createElementVNode("source", {
            src: _ctx.vm.backgroundVideoUrl
          }, null, 8, _hoisted_2)
        ]))
      : (_ctx.vm.backgroundImageUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              alt: _ctx.vm.backgroundImageAlt,
              class: "hero__background__image",
              src: _ctx.vm.backgroundImageUrl
            }, null, 8, _hoisted_4)
          ]))
        : (_ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.magenta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.vm.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_11, _toDisplayString(_ctx.vm.title), 1))
            : _createCommentVNode("", true),
          (_ctx.vm.subtitle)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(_ctx.vm.subtitle), 1))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.vm.hideSearch && _ctx.vm.searchBarVerticalAlignment === _ctx.VerticalAlignmentEnum.top)
          ? (_openBlock(), _createBlock(_component_HeroSearchBar, {
              key: 0,
              vm: _ctx.vm
            }, null, 8, ["vm"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.vm.ctaButton)
            ? (_openBlock(), _createBlock(_component_LinkButton, {
                key: 0,
                class: _normalizeClass(["p-button-success p-button-raised p-button-arrow", { 'p-button-lg': !_ctx.isSmallScreen }]),
                label: _ctx.vm.ctaButton.text,
                target: _ctx.vm.ctaButton.target,
                title: _ctx.vm.ctaButton.title,
                url: _ctx.vm.ctaButton.url
              }, null, 8, ["class", "label", "target", "title", "url"]))
            : _createCommentVNode("", true),
          (_ctx.vm.ctaLink)
            ? (_openBlock(), _createBlock(_component_LinkButton, {
                key: 1,
                class: _normalizeClass(["p-button-link", {
							'p-button-lg': !_ctx.isSmallScreen,
							'p-button-primary':
								_ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.grey || _ctx.vm.backgroundImageUrl,
						}]),
                label: _ctx.vm.ctaLink.text,
                target: _ctx.vm.ctaLink.target,
                title: _ctx.vm.ctaLink.title,
                url: _ctx.vm.ctaLink.url
              }, null, 8, ["class", "label", "target", "title", "url"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.vm.hideCompanyLogos && _ctx.vm.companyLogoUrls?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.companyLogoUrls, (companyLogo, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _withDirectives(_createElementVNode("img", {
                    alt: 'companyLogo' + i
                  }, null, 8, _hoisted_17), [
                    [_directive_lazy, companyLogo]
                  ])
                ]))
              }), 128))
            ]),
            (!_ctx.vm.hideSearch && _ctx.vm.searchBarVerticalAlignment === _ctx.VerticalAlignmentEnum.bottom)
              ? (_openBlock(), _createBlock(_component_HeroSearchBar, {
                  key: 0,
                  vm: _ctx.vm
                }, null, 8, ["vm"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.companyLogoUrls, (companyLogo, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _withDirectives(_createElementVNode("img", {
                      alt: 'companyLogo' + i
                    }, null, 8, _hoisted_20), [
                      [_directive_lazy, companyLogo]
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ((_ctx.vm.hideCompanyLogos || !_ctx.vm.companyLogoUrls?.length) && !_ctx.vm.hideSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (!_ctx.vm.hideSearch && _ctx.vm.searchBarVerticalAlignment === _ctx.VerticalAlignmentEnum.bottom)
              ? (_openBlock(), _createBlock(_component_HeroSearchBar, {
                  key: 0,
                  vm: _ctx.vm
                }, null, 8, ["vm"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}